export const BUTTON_COLOR_PRIMARY = "color-neutral";
export const BUTTON_COLOR_SECONDARY = "color-neutral-shade-80";
export const BUTTON_COLOR_TERTIARY = "color-neutral-shade-80";
export const BUTTON_COLOR_DISABLED = "color-neutral-shade-80";
export const BUTTON_COLOR_GHOST = "color-neutral-shade-80";
export const BUTTON_COLOR_NEGATIVE = "color-error";
